$ ->
  form = $ '[data-bulk-edit-form]'
  learning_budget_fields = ['learning_budget[0][type]','learning_budget[0][strategy]']

  init_editor = () ->
    if form.length <= 0
      return

    groups = form.find '.form-group'
    for group in groups
      group = $ group
      if group.hasClass('form-actions')
        continue
      init_group group

    changed_fields = form.data('bulk-edit-changed-fields') || []
    for field in changed_fields
      if 'learning_budget' == field
        field = 'temp_learning_budget_list'
      enable_group $ ".form-group[data-field-name='#{field}']"

    INTENT.utils.Tooltip.init()


    $(document).on 'switchChange.bootstrapSwitch', '.on-off', ->
      el = $ this
      isOn = el.bootstrapSwitch 'state'
      targetFieldName = $("[data-switch-handler='#{el.data 'switchTarget'}']").prop 'name'
      disabledFieldName = 'bulk_edit_disabled_fields[]'
      disabledFieldInDom = form.find("input[name='#{disabledFieldName}']").filter "[value='#{targetFieldName}']"
      handle_learning_budget()
      if not isOn
        if not disabledFieldInDom.length and not _.contains(learning_budget_fields, targetFieldName)
          add_hidden disabledFieldName, targetFieldName
      else
        disabledFieldInDom.remove()

  handle_learning_budget = ->
    lb = $("[name=temp_learning_budget_list]")
    if lb.length
      lb.val().split '::'
      for key, f of learning_budget_fields
        $(f).val lb[key]

  add_hidden = (name, value) ->
    $('<input>', {
      type: 'hidden'
      name: name
      value: value
    }).appendTo form


  init_group = (group) ->
    group = get_group group
    if group?
      name = group.attr 'data-field-name'
      group.addClass 'bulk_edit__form_group_off'
      group.prepend get_controls_html(name)
      group.prepend get_group_holder_html()

  get_group = (group) ->
    if not (group instanceof jQuery)
      group = $ group

    return if group.length then group else undefined

  enable_group = (group) ->
    group = get_group group
    if group?
      name = group.attr 'data-field-name'
      set_changed_field name, true

      group.removeClass 'bulk_edit__form_group_off'
      group.find('[data-bulk-edit-control="on"]').addClass 'hidden'
      group.find('[data-bulk-edit-control="off"]').removeClass 'hidden'

  disable_group = (group) ->
    group = get_group group
    if group?
      name = group.attr 'data-field-name'
      set_changed_field name, false

      group.addClass 'bulk_edit__form_group_off'
      group.find('[data-bulk-edit-control="on"]').removeClass 'hidden'
      group.find('[data-bulk-edit-control="off"]').addClass 'hidden'

  set_changed_field = (field, changed) ->
    if 'temp_learning_budget_list' == field
      return add_hidden 'bulk_edit_changed_fields[]', 'learning_budget'
    $("input[name='bulk_edit_changed_fields[]'][value='#{field}']").prop 'checked', changed

  get_group_holder_html = () ->
    """
      <div class='bulk_edit__form_holder' data-bulk-edit-control='on'>
        <div class='bulk_edit__form_holder_body'>&nbsp;</div>
      </div>
    """

  get_controls_html = (name) ->
    """
    <div class='bulk_edit__form_field_controls'>
      <span data-bulk-edit-control='on'>
      <i class='fa fa-fw fa-pencil opacity-dynamic'
         title='#{__("bulk-edit.controls.on.hint")}'
         data-toggle='tooltip'></i>
      </span>
      <span data-bulk-edit-control='off' class='hidden'>
        <i class='fa fa-fw fa-undo opacity-dynamic'
           title='#{__("bulk-edit.controls.off.hint")}'
           data-toggle='tooltip'></i>
      </span>
      <input class='hidden'
             type='checkbox'
             name='bulk_edit_changed_fields[]'
             value='#{name}'>
    </div>
    """

  $(document).on 'click', '[data-bulk-edit-control]', (e) ->
    e.preventDefault();
    self = $ e.currentTarget
    action = self.attr('data-bulk-edit-control')
    group = self.closest '.form-group'

    if action is 'on'
      enable_group group
    else if action is 'off'
      disable_group group

  do init_editor;